var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97658 0.266124L8.49958 6.78912L15.0898 0.266124C15.8295 -0.540845 17.04 0.669608 16.233 1.47658L9.71003 7.99958L16.233 14.5898C17.04 15.3295 15.8295 16.54 15.0898 15.733L8.49958 9.21003L1.97658 15.733C1.16961 16.54 -0.0408447 15.3295 0.766124 14.5898L7.28912 7.99958L0.766124 1.47658C-0.0408447 0.669608 1.16961 -0.540845 1.97658 0.266124Z",
    fill: "#838383"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.24dbad3b2415c5c1b47e67ea98418ebb.svg";